/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../../Fixes';
import Builder from '../../../../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "rst": {
                            "nested": {
                              "common": {
                                "nested": {
                                  "TextCustomer": {
                                    "fields": {
                                      "promptBeforeCheckout": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional",
                                        "options": {
                                          "default": false
                                        }
                                      },
                                      "promptWhenNeeded": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional",
                                        "options": {
                                          "default": false
                                        }
                                      },
                                      "customerPhoneNumberOptional": {
                                        "type": "bool",
                                        "id": 3,
                                        "rule": "optional",
                                        "options": {
                                          "default": false
                                        }
                                      },
                                      "customerIdentificationType": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.rst.common.TextCustomer.CustomerIdentificationType",
                                        "id": 4,
                                        "rule": "optional",
                                        "options": {
                                          "default": "CUSTOMER_NAME"
                                        }
                                      }
                                    },
                                    "nested": {
                                      "CustomerIdentificationType": {
                                        "values": {
                                          "CUSTOMER_NAME": 0,
                                          "TABLE_NUMBER": 1,
                                          "ORDER_NUMBER": 2
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.rst?.nested?.common?.nested?.TextCustomer && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.rst?.nested?.common?.nested?.TextCustomer?.nested?.CustomerIdentificationType) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE TextCustomer @ squareup/devicesettings/profiles/v2/model/settings/rst/common/text_customer.proto at 17:1
 */
export const TextCustomer = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.rst.common.TextCustomer');
fixType(TextCustomer);
Builder.createAndAttachToType(TextCustomer);
/**
 * SOURCE CustomerIdentificationType @ squareup/devicesettings/profiles/v2/model/settings/rst/common/text_customer.proto at 18:3
 */
TextCustomer.CustomerIdentificationType = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.rst.common.TextCustomer.CustomerIdentificationType').values;